/** Dependency injection tokens */

import { InjectionToken } from "@angular/core";

// Delay to be used to debounce animation requests
export const ANIMATIONS_DEBOUNCE_DELAY = new InjectionToken<number>("ANIMATIONS_DEBOUNCE_DELAY", {
  factory: () => 50,
});
